module.exports = __webpack_public_path__ + "media/src/images/mails/certify_your_learning-d91d2ace00d126da9fef033e9b0968dd.jpg";